// How a camera's photos are turned for DISPLAY. The backend stores this per camera
// (Device.camera_image_rotation, returned as `rotation_deg` on every image payload and
// `image_rotation_deg` on camera-status) so every browser and teammate agrees; the
// stored JPEG is never rotated. Only 0 and 180 exist - anything else (an older backend
// without the field, a bad value) means "leave it as taken".
export const imageRotationClass = (rotationDeg) => (Number(rotationDeg) === 180 ? "rotate-180" : "");
